module.exports = __webpack_public_path__ + "static/media/packBG.4132ed1b.png";